<template>
  <div class="success_home">
    <w-title-bar v-show="clientType" :title="title" textColor="#000000"></w-title-bar>
    <div id="content" class="about_background content">
      <img class="success_top" src="/static/success_top.png" />
      <div>
        <img class="success_center" :src="srcFlag?'/static/success_center.png':'/static/success_center_en.png'" />
        <div class="text-pass">{{i18n.pass}}</div>
      </div>

      <el-card class="picture-position">
        <div class="block">
          <el-image src="/static/no_product.png"></el-image>
          <div class="middle">{{i18n.notget}}</div>
        </div>
      </el-card>
      <button class="backToHome" @click="gotoHome">{{i18n.button}}</button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import wTitleBar from "@/components/w-titleBar";
export default {
  name: "error",
  components: {
    wTitleBar,
  },
  data() {
    return {
      labelPosition: "left",
      title: '',
      srcFlag: true,
      clientType: true,
    };
  },
  mounted() {
    let divContent = document.getElementById("content").clientHeight;
    let screenHeight = document.body.clientHeight;
    document.getElementById("content").style.cssText =
      "height: " + (divContent - 44) + "px;";
    window.initNfc = null;
    window.doSingle = null;
   //中英文
    if(navigator.language.indexOf("zh") != -1){
      this.srcFlag = true;
    } else {
      this.srcFlag = false;
    }
    if(this.$route.query.data === '1') {
      this.clientType = false;
    };
  },
  computed: {
    i18n() {
      this.title = this.$t('error.title');
      return this.$t('error');
    }
  },
  methods: {
    gotoHome() {
      this.$router.replace({path: '/home'})
    },
  },
};
</script>

<style lang="less" scoped>
.about_background {
  background-color: #f6f6f6;
}
.content {
  // margin-top: -44px;
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
.success_top {
  // margin-top: 44px;
  width: 100vw;
}
.success_center {
  // background-image: url(/static/success_center.png); /* 引入图片 */
  // background-size: 100vw; /* 设置图片的大小 */
  // background-repeat: no-repeat;
  // // background-position: 50% -40%;
  // width: 100%;
  // height: 100%;
  // position: absolute;
  // z-index: 3;

  width: 100vw;
  margin-top: -50%;
}
.text-pass {
  margin-top: -42%;
  text-align: center;
  font-size: 20px;
  font-family: PingFang;
  font-weight: 700;
  color: rgba(43, 27, 2, 1);
  line-height: 65px;
}
.text-test {
  font-size: 15px;
  text-align: center;
  font-family: PingFang;
  font-weight: 500;
  color: rgba(208, 2, 27, 1);
  line-height: 37px;
}
.picture-position {
  // margin-top: 18%;
  margin-top: 22%;
  margin-left: 10px;
  margin-right: 10px;
  height: 240px;
  border-radius: 20px;
}
.image {
  width: 100%;
  display: block;
}
.content-position {
  margin-top: 2%;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
}
.my_head {
  width: 1.2rem;
  height: 1.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
  margin-left: -240px;
  font-family:PingFang;
}
.my_head_background {
  margin-left: -20px;
  height: 2.2rem;
  margin-right: 5px;
  text-align: center;
  font-size: 18px;
  vertical-align: middle;
}
.header {
  padding: 10px 0px;
  box-sizing: border-box;
  margin-top: -10px;
}
.no-padding {
  padding: 0px;
}
.el-carousel__item img {
  height: 200px;
  clear: both;
  display: block;
  margin: auto;
}
.middle {
font-size:14px;
font-family:PingFang;
font-weight:400;
color:#9B999A;
text-align: center;
}
.backToHome{
  width: 95%;
  height:45px;
  background: url(/static/buttonback.png) no-repeat;
  background-size:100% 100%; 
  border-style: none;
  margin-top: 20px;
  transform: translate(2.5%, 0%);
  font-family:PingFang;
}
</style>



// WEBPACK FOOTER //
// src/pages/result/error.vue